export const FUNC_FORM = 'FUNC_FORM';
export const MONOMER_FORM = 'MONOMER_FORM';
export const FINAL_RESULTS = 'FINAL_RESULTS';